<template>
  <div class="mt-2">
    <p class="mb-2 lead d-flex justify-content-between">
      <span>Comprobación de estado del dispositivo del panel</span>
      <span class="small">{{ action.data.timestamp }}</span>
    </p>

    <div class="mb-1 device-status-container" v-if="deviceData.name">
      <table class="table table-striped w-50">
        <tr>
          <th>Dispositivo</th>
          <td class="fw-bold">{{ deviceData.name }}</td>
        </tr>
        <tr>
          <th>Estado</th>
          <td class="fw-bold">
            <span class="mr-1" v-if="!validStatus.includes(deviceData.status)">
              <feather-icon icon="AlertTriangleIcon" size="18" class="text-danger"/>
            </span>
            <span v-else>
              <feather-icon icon="CheckIcon" size="18" class="text-success"/>
            </span>
            {{ deviceData.status }}
          </td>
        </tr>
        <tr>
          <th>Tipo</th>
          <td class="fw-bold">{{ deviceData.type }}</td>
        </tr>
      </table>
    </div>

    <b-button
      variant="success"
      @click="checkDevice()"
      :disabled="isProcessing || action.data.completed"
    >
      <b-spinner small v-if="isProcessing && !action.data.completed"></b-spinner>
      Validar dispositivo
    </b-button>

    <div class="text-right mb-1">
      <b-button
        variant="primary"
        size="sm"
        @click="onContinueClick(action)"
        v-if="!action.data.continue && !terminated"
      >
        {{ $t("action_plan.viewer.continue") }}
        <feather-icon icon="ChevronRightIcon" size="18"/>
      </b-button>
    </div>
  </div>
</template>

<script>
import axios from "@axios";

const validStatus = ['RESTORED', 'NORMAL'];

export default {
  name: "PanelDeviceStatusCheck",
  components: {},
  props: {
    actionPlanLogUuid: String,
    alarmId: String | Number,
    action: Object,
    terminated: Boolean,
    preview: Boolean,
    validating: Boolean,
  },
  data() {
    return {
      deviceData: {},
      isProcessing: false,
      validStatus
    }
  },
  created() {
  },
  async mounted() {
    if (this.preview) return;
    if (!this.alarmId) return;

    await this.checkDevice();
  },
  beforeDestroy() {
  },
  methods: {
    fetchDeviceData() {
      return axios.get(`v1/dmp/device-status?alarm_id=${this.alarmId}`)
    },
    checkDevice() {
      this.isProcessing = true;
      this.fetchDeviceData()
        .then(({data}) => {
          this.deviceData = data.data;
          this.validate();
        })
        .catch((error) => console.error('error fetching device data', error))
        .finally(() => this.isProcessing = false);
    },
    async validate() {
      this.$set(this.action.data, 'completed', validStatus.includes(this.deviceData.status));
    },
    onContinueClick(action) {
      this.$emit("continue", action);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
